<div class="flex max-h-[90vh] flex-col gap-2 p-6">
  <div class="flex">
    <h3 class="flex-1">Детальніше про ліміт</h3>
    <button
      mat-dialog-close
      class="self-end"
    >
      <mat-icon
        aria-hidden="false"
        aria-label="Close icon"
      >close</mat-icon>
    </button>
  </div>
  <div class="flex flex-col gap-6 overflow-y-auto">
    @for (limit of limits(); track limit.limitRuleName) {
      <div>
        @if (limit.limitType === limitType.Price) {
          <div class="mb-4 flex items-center gap-2">
            <mat-icon class="text-warning-500">gpp_maybe</mat-icon>
            <div class="text-neutral-300">{{ setRuleMessage(limit) }}:</div>
            <div class="text-neutral-500">{{ limit.limitAmount }} грн</div>
          </div>
          @if (limit.usedLimitedPrescriptions.length > 0) {
            <div class="mb-2 flex px-4 text-neutral-300">
              <div class="w-4/5">Використані послуги</div>
            </div>
            <div class="flex flex-col gap-2">
              @for (prescription of limit.usedLimitedPrescriptions; track prescription.id) {
                <div class="flex items-center rounded-xl border-2 border-neutral-100 bg-neutral-100 px-4 py-2">
                  <div class="w-4/5">{{ prescription.name }}</div>
                </div>
              }
            </div>
          } @else {
            <ng-container [ngTemplateOutlet]="noUsedPrescriptions"></ng-container>
          }
        }
        @if (limit.limitType === limitType.Quantity) {
          <div class="mb-4 flex items-center gap-2">
            <mat-icon class="text-warning-500">gpp_maybe</mat-icon>
            <div class="paragraph-1 text-neutral-300">{{ setRuleMessage(limit) }}:</div>
            <div class="subheader-1 text-neutral-500">{{ limit.limitAmount }} послуг</div>
          </div>
          @if (limit.usedLimitedPrescriptions.length > 0) {
            <div class="paragraph-2 mb-2 flex px-4 text-neutral-300">
              <p class="w-4/5">Використані послуги</p>
            </div>
            <div class="flex flex-col gap-2">
              @for (prescription of limit.usedLimitedPrescriptions; track prescription.id) {
                <div class="flex items-center rounded-xl bg-neutral-100 px-4 py-2">
                  <p class="subheader-2 w-4/5">{{ prescription.name }}</p>
                </div>
              }
            </div>
          } @else {
            <ng-container [ngTemplateOutlet]="noUsedPrescriptions"></ng-container>
          }
        }
      </div>
    }
  </div>
</div>

<ng-template #noUsedPrescriptions>
  <div class="flex items-center rounded-xl border-2 border-neutral-100 bg-neutral-100 px-4 py-2">
    <p class="subheader-2 text-neutral-300">Ліміт ще не застосовувався до жодного призначення в правилі</p>
  </div>
</ng-template>
